import { Component, OnInit, Renderer2, Inject, ChangeDetectorRef, NgZone, Input, Output, EventEmitter } from '@angular/core'; 
import { ActivatedRoute, Router } from "@angular/router" 
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { LoaderService } from '@modules/loader';  
import _ from 'lodash'; 
import { QuestionSecurityModel,QuestionSecurityReponseModel } from '@shared/security/question-security.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SecurityQuestionRequest } from '@shared/security/security-question-request.model';
import { __asyncValues } from 'tslib';
import { ConfirmationService } from 'primeng/api'; 
import { AccountService } from '@services/account.service';


@Component({
  selector: 'app-question-security',
  templateUrl: './question-security.component.html',
  styleUrls: ['./question-security.component.scss'] 
})
export class QuestionSecurityComponent implements OnInit  {  
    isLoading :boolean=false;
    infoMessage:string;  
    userId:string;
    token:string;
    step:number = 1;
    page:string;
    isError:boolean=false;
    private _submitted:boolean=false; 
    isConfirmed:boolean=false;
    CryptedEmail:string;
    model: QuestionSecurityModel;
    questions:QuestionSecurityModel[]=[];
    securityForm: FormGroup;
  selectedSecurityQuestion: any;
  reponseModel: QuestionSecurityReponseModel;
  private responseModel: SecurityQuestionRequest;
  response: string;
    get f() { return this.securityForm.controls; }

    @Input()
    set ResponseModel(value : SecurityQuestionRequest){
      this.responseModel = value;
      this.emitValidation();
      this.init();
    } 
    get ResponseModel() : SecurityQuestionRequest{
      return this.responseModel;
    }
    @Output() validate = new EventEmitter<boolean>();

    @Input()
  set submitted(value: boolean) {
    setTimeout(() => {
      this._submitted = value;  
      this.emitValidation();
    }, 300);
  }
  get submitted(): boolean { return this._submitted; }

    constructor(private accountService : AccountService,private authService: AuthenticationService,
        private router: Router,
        private formBuilder: FormBuilder,
        private route:ActivatedRoute, 
        private changeDedectionRef :ChangeDetectorRef,
        private loaderService: LoaderService, private renderer: Renderer2,
        @Inject(DOCUMENT) private _document,   private zone: NgZone,
        private confirmationService:ConfirmationService) {
        }

        
  ngOnInit() {    
    this.buildForm();
    this.questions = [];
    this.initQuestions();
    this.securityForm.valueChanges.subscribe(() =>
    this.emitValidation()); 
    this.init();
  }

  ngAfterContentChecked(): void {
     this.changeDedectionRef.detectChanges();
  }  

  init(){
    if(this.securityForm){
      this.initQuestions();
       this.selectQuestion(); 
      this.securityForm.controls['Response'].setValue(this.responseModel.Response);
    }
  }

  selectQuestion() { 
    const _this = this;
    let result = this.questions.filter(function (e) {
      return e.IdQuestion === _this.responseModel.IdQuestion;
    });
    this.selectedSecurityQuestion = result != null && result.length > 0 ? result[0] : null;
    this.securityForm.controls['SecurityQuestion'].setValue(this.selectedSecurityQuestion);
  }

  validateFunction(): Function {
    return _.debounce(() => {
      this.validate.emit(this.securityForm.valid);
    }, 300);
  }

  emitValidation() {
    this.validateFunction()();
  }

   initQuestions(){
    this.questions =  this.accountService.getSecurityQuestions();  
   }

  buildForm() {

    this.securityForm = this.formBuilder.group({
      'SecurityQuestion': ['', Validators.required],
      'Response': ['', Validators.required],
    });

    this.securityForm.controls['SecurityQuestion'].valueChanges.subscribe(value => {
      if(value != null)
      { 
        this.selectedSecurityQuestion = value;
        this.responseModel.Question = value.Question;
        this.responseModel.IdQuestion = value.IdQuestion;
      }
    }); 

    this.securityForm.controls['Response'].valueChanges.subscribe(value => { 
      this.response = value;
      this.responseModel.Response = value;
    });
  }
 redirectToLogin(){
  this.router.navigate(['/login']);
 }

 redirectToCreatePassword(url : string){
  this.zone.runOutsideAngular(() => {
    window.location.href = url;
  }); 
 } 
}

 